import React from 'react';

import NotifierBanner from 'flow/components/custom-components/NotifierBanner';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppSelector } from 'flow/hooks/useRedux';
import {
    CompanionRequirement,
    CompanionRequirementType,
    selectCompanionRequirement,
} from 'flow/selectors/companion-selectors';

const messageKeys: Record<CompanionRequirementType, string | null> = {
    [CompanionRequirement.MET]: null,
    [CompanionRequirement.PENDING]: null,
    [CompanionRequirement.NOT_ENABLED]: 'companion.required.not_enabled',
    [CompanionRequirement.HANDOVER_OFF]: 'companion.required.handover_off',
    [CompanionRequirement.NO_COMPANION]: 'companion.required.no_device',
    [CompanionRequirement.LOCATION_BLOCKED]:
        'companion.required.location_blocked',
    [CompanionRequirement.OUTSIDE_REGION]: 'companion.required.outside_region',
};

const CompanionRequiredNotifier = () => {
    const requirement = useAppSelector(selectCompanionRequirement);
    const { i18next } = useAppContext();

    const messageKey = messageKeys[requirement];

    if (!messageKey) {
        return null;
    }

    return <NotifierBanner message={i18next.t(messageKey)} theme={'warning'} />;
};

export default CompanionRequiredNotifier;
